// tslint:disable
import { get } from 'lodash';
import * as React from 'react';
import { InputField } from '../../components/fields/input.field';
import { ConsoleLib } from '../../components/libs/console.lib';
import { ListResourceLoader } from '../../components/libs/list-resource-loader';
import { ListLib } from '../../components/libs/list.lib';
import { ListConsole } from '../../components/structurals/list-console';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { Pagination } from '../../components/structurals/pagination';
import { ListActions, ListResponsePresenterTable } from '../../components/structurals/presenters/list-response-presenter-table';

export class DefaultArticleHolidayTypeList extends React.Component<any, any> {

    async handleItemDelete(item: any, list: ListLib, listActions: ListActions, event: any) {
        event.preventDefault();
        event.stopPropagation();

        list.isLoading$.next(true);
        await listActions.delete(item['@id']);
        list.refetch();
    }

    render() {
        return (
            <ListResourceLoader forceQuery={{'order[title]': 'ASC'}} entity="article-holiday-type" render={(list: ListLib) => <div>
                <div id="page-title">
                    <h2>
                        Article holiday types
                        <div className="pull-right">
                            <a href="/article-holiday-type/create" className='btn btn-sm btn-primary'>Create new Holiday type</a>
                        </div>
                    </h2>
                    <p>Lorem</p>
                </div>

                <ListConsole
                    className="col-xs-12 col-lg-3 pull-right"
                    config={list.console}
                    render={(console: ConsoleLib) => <div>
                        <InputField field={console.setQuery('title', {title: 'Search in types', placeholder: 'some keyword'})}/>
                    </div>}
                />

                <div className="col-xs-12 col-lg-9 pull-left relative">
                    <LoaderComponent isLoading$={list.isLoading$}/>

                    <ListResponsePresenterTable
                        items={list.member}
                        head={() => {
                            return (
                                <tr>
                                    <th>#</th>
                                    <th>Type</th>
                                    <th></th>
                                </tr>
                            );
                        }}
                        row={(item: any, index: number, actions: ListActions) => {
                            return (
                                <tr key={index}>
                                    <td>{get(item, 'id', '-')}</td>
                                    <td>{get(item, 'name', '-')}</td>
                                    <td>
                                        <button className="btn btn-xs btn-primary" onClick={() => actions.open(item['@id'])}>View details</button>
                                    </td>
                                </tr>
                            );
                        }}/>

                    <Pagination config={list.pagination}/>
                </div>
            </div>}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/lists/default.article-holiday-type.list.tsx